import APIRequestHelper from '../helpers/api-request-helper';

const SubscriptionService = {
  async getCurrentSubscription() {
    return APIRequestHelper.sendRequest('Get', 'subscriptions', false, null);
  },
};
export default SubscriptionService;

